import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import MessageBox    from './message-box';
import MessageInput  from './message-input';
// -------------------------------------------------------


class InfluencerMessage extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let detail = this.props.detail;
    
    // メインアカウントを優先する
    let main_dm_account = null;
    try {
      detail.dm_messages.accounts.map((d) => { if( d.id === this.props.base.project.detail.main_dm_account ) main_dm_account = d.id; });
    } catch(e) {}
    if( main_dm_account == null ) main_dm_account = detail.dm_messages.last_message_account;
    
    this.state = {
      account_id : main_dm_account,
      height     : 0,
      submit_flg : false,
      message_active      : false,
      message_contents    : {},
      change_account_mode : false,
      is_show_pdf : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * スクロール位置調整
   */
  componentDidMount(props) {
    setTimeout( function(){
      this.setMessagePosition.bind(this)();
      this.sendAlreadyRead.bind(this)();
    }.bind(this), 150);
  }
  // -------------------------------------------------------
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if( nextProps.tab == 'message' ){
      this.setMessagePosition.bind(this)();
    }
  }
  // -------------------------------------------------------
  
  /*
   * アカウント変更
   */
  changeAccount(account_id) {
    this.setState({ account_id: this.accounts.value, change_account_mode: false });
    this.setMessagePosition.bind(this)();
    
    setTimeout( function(){
      this.sendAlreadyRead.bind(this)();
    }.bind(this), 150);
  }
  // -------------------------------------------------------
  
  changeAccountMode() {
    this.setState({ change_account_mode: true });
  }
  // -------------------------------------------------------
  
  /*
   * メッセージの高さ設定
   */
  setMessageHeight(height) {
    this.setState({ height: height });
  }
  // -------------------------------------------------------
  
  /*
   * メッセージの高さ設定
   */
  setPdfFlg(flg) {
    this.setState({ is_show_pdf: (this.state.is_show_pdf == false) ? true : false });
  }
  // -------------------------------------------------------
  
  /*
   * メッセージの設定
   */
  setMessageContents(message_contents) {
    this.setState({ message_contents: message_contents, message_active: (Object.keys(message_contents).length > 0) });
  }
  // -------------------------------------------------------
  
  /*
   * スクロール位置調整
   */
  setMessagePosition(props) {
    setTimeout( function() {
      try {
        let element = document.getElementById('dm-message-list');
        element.scroll(0, (element.scrollHeight - element.clientHeight));
      } catch(e) {}
    }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  /*
   * メッセージ送信処理
   */
  submit() {
    let insta_user_id = this.props.detail.influencer.insta_user_id;
    let dm_account_id = this.state.account_id;
    
    this.setState({ submit_flg: true });
    
    let message_contents = this.state.message_contents;
    if( Object.keys(message_contents).length == 0 ) return;
    
    Utils.request.bind(this)('/api/project/influencer/send_dm', { message_contents: message_contents, insta_user_id: insta_user_id, dm_account_id: dm_account_id },
      function(res){
        this.props.refresh_ev.bind(this)(insta_user_id, false);
        
        setTimeout( function(){ this.setState({ submit_flg: false }); }.bind(this), 50);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * メッセージキャンセル
   */
  cancel() {
    this.props.base.event.setMessageMode.bind(this)(false);
  }
  // -------------------------------------------------------
  
  /*
   * 既読送信処理
   */
  sendAlreadyRead() {
    let project_id    = this.props.base.project.id;
    let insta_user_id = this.props.detail.influencer.insta_user_id;
    let dm_account_id = this.state.account_id;
    
    
    let dm = Object.assign({}, this.props.base.dm_already_read);
    if( dm[insta_user_id] == undefined || dm[insta_user_id][dm_account_id] == undefined ) return;
    
    Utils.request.bind(this)('/api/project/influencer/dm_already_read', { project_id: project_id, insta_user_id: insta_user_id, dm_account_id: dm_account_id },
      function(res){
        
        delete dm[insta_user_id][dm_account_id];
        this.props.base.event.updateData.bind(this)('dm_already_read', dm);
        
      }.bind(this),
      function(res){
        
      }.bind(this)
      , false
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    let message_mode = this.props.message_mode;
    
    let detail = this.props.detail;
    let dm = detail.dm_messages;
    
    let messages = dm.messages[this.state.account_id];
    if( messages == undefined ) messages = [];
    
    let account = {};
    let accountObj = Utils.createColumnObject(dm.accounts, 'id');
    try { if( accountObj[this.state.account_id] != undefined ) account = accountObj[this.state.account_id]; } catch(e) {}
    
    let message_height = (message_mode == true) ? (140 + this.state.height) : 120;
    
    // メインアカウントの場合は、そのまま利用可能とする
    let main_message_mode = false;
    if( this.state.account_id == this.props.base.project.detail.main_dm_account && (messages.length > 0) ){
      main_message_mode = true;
    }
    
    let post_guide_url = null;
    try {
      const regex = /\/file\/d\/([a-zA-Z0-9_-]+)/;
      const match = base.project.detail.post_guide_url.match(regex);
      if( match ) post_guide_url = match[1];
    } catch(e) {}
    console.log(post_guide_url);
    
    // メッセージモード
    if( message_mode == true && messages.length > 0){
      return (
        <div className="influencer-contents-message-box">
          
          { (post_guide_url != null) &&
            <div>
              { (this.state.is_show_pdf == true) ? <p className="pdf on" onClick={this.setPdfFlg.bind(this)}>指示書PDF <span>×</span></p> : <p className="pdf off" onClick={this.setPdfFlg.bind(this)}>指示書PDF</p> }
              { (this.state.is_show_pdf == true) && <ShowPdf post_guide_url={post_guide_url} /> }
            </div>
          }
          
          <div className="preview-header none">
            <div className="preview-account">
              <img src={account.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
              <span>{account.insta_id}</span>
            </div>
            <i className="material-icons">arrow_forward</i>
            <div className="preview-account">
              <img src={detail.influencer.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
              <span>{detail.influencer.insta_id}</span>
            </div>
          </div>
          
          <div className="message-box" style={{ height: 'calc(100% - '+ (message_height)  +'px)' }}>
            <MessageBox base={base} messages={messages} dm={dm} height={this.state.height} message_mode={message_mode} />
          </div>
          
          <MessageInput message_contents={this.state.message_contents} height_ev={this.setMessageHeight.bind(this)} submit_ev={this.submit.bind(this)} change_ev={this.setMessageContents.bind(this)} />
          
          <div className="yes-no">
            { (this.state.message_active == true)
              ? <p className="button yes" onClick={this.submit.bind(this)}><i className="material-icons">send</i>送信</p>
              : <p className="button yes off"><i className="material-icons">send</i>送信</p>
            }
            <p className="button no" onClick={this.cancel.bind(this)}>キャンセル</p>
          </div>
        </div>
      );
    }
    
    // 優先メッセージモード
    if( main_message_mode == true && messages.length > 0 && this.state.change_account_mode == false){
      return (
        <div className="influencer-contents-message-box main-message-mode">
          
          { (post_guide_url != null) &&
            <div>
              { (this.state.is_show_pdf == true) ? <p className="pdf on" onClick={this.setPdfFlg.bind(this)}>指示書PDF <span>×</span></p> : <p className="pdf off" onClick={this.setPdfFlg.bind(this)}>指示書PDF</p> }
              { (this.state.is_show_pdf == true) && <ShowPdf post_guide_url={post_guide_url} /> }
            </div>
          }
          
          <div className="account-setting">
            <h6>送信するアカウント</h6>
            
            <div className="preview-account">
              <img src={account.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
              <p>{account.insta_id}</p>
            </div>
            
            <div className="message-mode-button" onClick={this.changeAccountMode.bind(this)}>変更</div>
          </div>
          
          <div className="message-box" style={{ height: 'calc(100% - '+ (message_height)  +'px)' }}>
            <MessageBox base={base} messages={messages} dm={dm} height={this.state.height} message_mode={message_mode} />
          </div>
          
          { (this.state.submit_flg == false ) && <MessageInput message_contents={this.state.message_contents} height_ev={this.setMessageHeight.bind(this)} submit_ev={this.submit.bind(this)} change_ev={this.setMessageContents.bind(this)} /> }
          
          <div className="yes-no">
            { (this.state.message_active == true)
              ? <p className="button yes" onClick={this.submit.bind(this)}><i className="material-icons">send</i>送信</p>
              : <p className="button yes off"><i className="material-icons">send</i>送信</p>
            }
            <p className="button no" onClick={base.event.setMessageMode.bind(this, true)}><i className="material-icons">zoom_out_map</i>拡大</p>
          </div>
        </div>
      );
    }
    
    return (
      <div className="influencer-contents-message-box">
        
        <div className="account-header">
          <h6>送信するアカウント</h6>
          { (base.event.showInsightLogin != undefined) &&<h6 className="edit" onClick={base.event.showInsightLogin.bind(this)}>設定</h6> }
        </div>
        <div className="selectbox">
          <select ref={(input) => { this.accounts = input }} onChange={this.changeAccount.bind(this)} defaultValue={this.state.account_id}>
            { dm.accounts.map((d, key) => {
              return <option key={key} value={d.id}>{(d.last_message_date == null) ? '×' : '◯' } @{d.insta_id}</option>
             })}
          </select>
        </div>
        
        { (messages.length > 0)
          ? <div className="message-box" style={{ height: 'calc(100% - '+ (message_height)  +'px)' }}>
              <MessageBox base={base} messages={messages} dm={dm} height={this.state.height} message_mode={message_mode} />
            </div>
          : <div className="message-box-none">
              <h3>メッセージのやり取りがありません</h3>
              <h4>初めてのやり取りは直接DMの送信をお願いします</h4>
              { (detail.influencer.dm_account_id == null)
                ? <a className="message-link button no" href="https://www.instagram.com/direct/new/" target="_blank">DM画面へ</a>
                : <a className="message-link button no" href={'https://www.instagram.com/direct/t/'+ detail.influencer.dm_account_id +'/'} target="_blank">DM画面へ</a>
              }
            </div>
        }
        
        { (messages.length > 0) &&
          <p className="button no message-mode-button" onClick={base.event.setMessageMode.bind(this, true)}>メッセージのやり取りを始める</p>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class ShowPdf extends React.Component {
  render() {
    let detail = this.props.detail;
    
    return (
      <div className="show-pdf">
        <iframe src={'https://drive.google.com/file/d/'+ this.props.post_guide_url +'/preview'} width="640" height="480" allow="autoplay"></iframe>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerMessage;